/**
 * MaterialCommunityIcons stub for web platform
 * Re-exports the HTML-based MaterialCommunityIcons implementation
 */
import { MaterialCommunityIcons } from './htmlIconStubs';
export default MaterialCommunityIcons;
